export const ROLES = {
  ADMIN: 'Admin',
  USER: 'User',
  INTEGRATIONS: 'Integrations',
  POLYVALENT: 'Polyvalent'
};
